/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
const state = {
    iosConfigList: [],
    androidConfigList: [],
    h5ConfigList: [],
    windowsConfigList: [],
    iosSdkVersion: [],
    androidSdkVersion: [],
    h5SdkVersion: [],
    windowsSdkVersion: [],
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
const actions = {
    GET_SDK_VERSION ({state, commit, dispatch, rootState}, args) {
        let data = [];
        rootState.$helper.request.get('/sdk/' + args.platform + '/versions', {
            platform: args.platform
        }).then(
            function (res) {
                data = res.data.sdk_versions;
                if (args.platform === 'IOS') {
                    commit('_iosSdkVersion', data);
                }
                else if (args.platform === 'H5') {
                    commit('_h5SdkVersion', data);
                }
                else if (args.platform === 'WINDOWS') {
                    commit('_windowsSdkVersion', data);
                }
                else {
                    commit('_androidSdkVersion', data);
                }
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },

    GET_CONFIG_LIST ({state, commit, dispatch, rootState}, args) {
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        let data = [];
        rootState.$helper.request.get('/games/' + gameCode + '/plans', {
            platform: args.platform,
            sdk_version_id: args.sdk_version_id
        }).then(
            function (res) {
                data = res.data.plans;
                if (args.platform === 'IOS') {
                    commit('_iosConfigList', data);
                }
                else if (args.platform === 'H5') {
                    commit('_h5ConfigList', data);
                }
                else if (args.platform === 'WINDOWS') {
                    commit('_windowsConfigList', data);
                }
                else {
                    commit('_androidCongfigList', data);
                }
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },
    DELETE_ROW ({state, commit, dispatch, rootState}, args) {
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        let data = [];
        rootState.$helper.request.delete('/games/' + gameCode + '/plans/' + args.plan_id, {platform: args.platform}).then(
            function (res) {
                data = res.data.deleted;
                if (data) {
                    dispatch('ALERT_HANDLE', {
                        message: '删除成功!',
                        callback () {
                            rootState.$helper.helper.route('sdk/configlist', {platform: data.platform.toUpperCase()});
                        }
                    }, {root: true});
                }
                else {
                    dispatch('ALERT_HANDLE', {
                        message: '删除失败!',
                        callback () {
                            rootState.$helper.helper.route('sdk/configlist');
                        }
                    }, {root: true});
                }
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
const getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
const mutations = {
    _iosConfigList (state, args) {
        state.iosConfigList = args;
        console.log('_iosConfigList=', state.iosConfigList);
    },
    _androidCongfigList (state, args) {
        state.androidConfigList = args;
        console.log('_androidCongfigList=', state.androidConfigList);
    },
    _h5ConfigList (state, args) {
        state.h5ConfigList = args;
        console.log('_h5CongfigList=', state.h5ConfigList);
    },
    _windowsConfigList (state, args) {
        state.windowsConfigList = args;
        console.log('_windowsCongfigList=', state.windowsConfigList);
    },
    _iosSdkVersion (state, args) {
        state.iosSdkVersion = args;
        console.log(state.iosSdkVersion);
    },
    _androidSdkVersion (state, args) {
        state.androidSdkVersion = args;
        console.log(state.androidSdkVersion);
    },
    _h5SdkVersion (state, args) {
        state.h5SdkVersion = args;
        console.log(state.h5SdkVersion);
    },
    _windowsSdkVersion (state, args) {
        state.windowsSdkVersion = args;
        console.log(state.windowsSdkVersion);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./website/store/modules/sdk/configList.js